import { ERROR_CODE } from "../config/errorCode"
import { api, ResponseMap } from "../utils/api.utils"

const requestUrl = process.env.NEXT_PUBLIC_REQUEST_URL

export type PrivatekeyType = {
    user_wallet_id: number | string;
    user_wallet_address: string;
    code: string;
    email_code: string;
    password: string;
    encrypted_aes_key: string;
};

export async function requestAddWallet(): Promise<{ code: number }> {
    const response = await api.post(
        `${requestUrl}/v1/account/add_wallet`,
        {
            json: {}
        }
    )

    if (!response.ok) {
        throw new Error(ERROR_CODE.NETWORK_ERROR)
    }

    const data = await response.json<ResponseMap<{ code: number }>>()
    return data
}


export async function requestExportPrivatekey(params:PrivatekeyType): Promise<{ code: number }> {
    const response = await api.post(
        `${requestUrl}/v1/account/export_privatekey`,
        {
            json: params
        }
    )

    if (!response.ok) {
        throw new Error(ERROR_CODE.NETWORK_ERROR)
    }

    const data = await response.json<ResponseMap<{ code: number }>>()
    return data
}


type WalletInfoProps = {
    wallet_group_id: number
}

export async function requestSetWalletInfo(params:WalletInfoProps): Promise<{ code: number }> {
    const response = await api.post(
        `${requestUrl}/v1/account/set_wallet_info`,
        {
            json: params
        }
    )

    if (!response.ok) {
        throw new Error(ERROR_CODE.NETWORK_ERROR)
    }

    const data = await response.json<ResponseMap<{ code: number }>>()
    return data
}
